<template>
    <div class="vitals-graph-body">
        <div class="vitals-graph-container">
            <v-chart v-if='xAxisValues.length > 0 && yAxisValues.length > 0' class="chart" :option="getOption()"
                autoresize />
            <div v-else>
                <h3 class="graphical-view-no-reading">Vital Readings not available</h3>
            </div>
            <div id="myDiv"></div>
        </div>
        <div class="vitals-stat-container pt-0" v-if='xAxisValues.length > 0 && yAxisValues.length > 0'>
            <div class="stat-block justify-content-center">
                <div class="stat-block-item">
                    <span class="stat-block-heading">Average</span>
                    <div class="stat-block-value">
                        <span class="value">{{ avgVal.slice(0, 5) }}</span>
                        <span class="unit">{{ unit }}</span>
                    </div>
                </div>
                <div class="stat-block-item">
                    <span class="stat-block-heading">Variability</span>
                    <div class="stat-block-value">
                        <span class="value">{{ minVal }}-{{ maxVal }} </span>
                        <span class="unit">{{ unit }}</span>
                    </div>
                </div>
                <!-- <div class="stat-block-status">More than average</div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
} from 'echarts/components';
import dayjs from '@/util/dayjs';
import VChart, { THEME_KEY } from 'vue-echarts';
import * as echarts from 'echarts';
import {calculateAverage} from '@/util/helpers/common.helpers.js';
use([
    CanvasRenderer,
    PieChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
]);
export default {
    name: 'LineWithCurvyChart',
    components: {
        VChart,
    },
    data() {
        return {

            buttons: [
                { caption: 'Weekly', state: true },
                { caption: 'Monthly', state: false },
                { caption: 'Custom Date', state: false },

            ],
            selectedVitalPeriod: 'Weekly',
            vitalStartDate: null,
            vitalEndDate: null,
            customRangeStartvalue: '',
            customRangeEndvalue: '',
            formatted: '',
            selected: '',
            yAxisValues: [],
            xAxisValues: [],
            minVal: null,
            maxVal: null,
            avgval: null,
            unit: "mg/dL"
        }
    },
    props: {
        vital: {
            type: Object,
            required: false
        },
        graphData: {
            type: Object||null
        }
    },
    methods: {

        vitalPeriodClickHandler(period) {
            this.selectedVitalPeriod = period
        },
        getOption() {
            return {
                tooltip: {
                    trigger: 'axis',
                    valueFormatter: (value) => `${value} ${this.unit}`
                },
                grid: {
                    left: '4%',
                    // right: '4%',
                    top: '3%',
                    bottom: '2%',
                    containLabel: true,
                    // show:true,
                    width: "auto",
                    background: "red",
                    // backgroundColor:"red",
                    backgroundColor:
                        "#ccc",
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {}
                //     }
                // },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                    data: this.xAxisValues,
                    axisLabel: {
                        show: true,
                        // interval:2,
                        // interval: (index, value, x) => {
                        //   if (index%5==0)
                        //     return false
                        //   return true
                        // },
                        rotate: 60,
                        // fontSize:"8px",
                        position: 'bottom'
                    },
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                },
                series: [
                    {
                        name: 'blood sugar',
                        type: 'line',
                        smooth: true,
                        stack: 'Total',
                        showSymbol: false,
                        data: this.yAxisValues,
                        lineStyle: {
                            color: "#5359c3",
                            width: 4,
                            opacity: 0.8
                        },
                        areaStyle: {
                            opacity: 0.1,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgba(58,77,233,0.9)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(58,77,233,0.2)'
                                }
                            ])
                        },
                    }
                ]
            }
        },
        formatRawVitalData(rawData) {
            let { avg, max, min, readings } = rawData;
            let readingsFormatted = [];
            if (readings && readings.length > 0) {
                readingsFormatted = readings.map((item) => ({ readAt: dayjs(item.readAt).format('MM/DD/YY h:mm A'), reading: Number(JSON.parse(item.reading).bgValue) })).reverse()
                this.minVal = min.value
                this.maxVal = max.value
                this.avgVal =avg!==null?avg:calculateAverage(readingsFormatted.map(item=>item.reading))+""
                this.yAxisValues = [
                    ...readingsFormatted.map(item => item.reading)
                ]
                this.xAxisValues = [
                    ...readingsFormatted.map(item => item.readAt),
                ]
            } else {
                this.xAxisValues = [];
                this.yAxisValues = [];
            }
        }
    }, computed: {
        customDateRangeSelected() {
            return this.selectedVitalPeriod === 'Custom Date'
        },

    },
    watch: {
        "graphData": {
            handler: function (value) {
                this.formatRawVitalData(value.data.getVitalReadings);
            },
            deep: true,
            immediate: true
        }
    }
}
</script>